<template>
    <div class="retr__row-header" :class="{ expandable: expandable }">
        <div class="retr__label" v-text="name" />

        <div class="retr__value" :class="{ 'font-weight-bold': bold }">
            <span v-if="typeof percent === 'number' && !isNaN(percent)">
                ({{ percent.toFixed(2) }}%)
            </span>

            <span v-if="percentValue && typeof value === 'number' && !isNaN(value)">
                {{ value }}%
            </span>
            <span v-else-if="typeof value === 'number' && !isNaN(value)">
                {{ value | currency }}
            </span>
            <span v-else v-text="'-'" />
        </div>

        <div class="retr__options">
            <template v-if="reclamationButton">
                <the-btn
                    v-tooltip="reclamationTooltip"
                    class="btn-sm btn-outline-custom w-100"
                    style="padding-left: 14px"
                    :disabled="btnDisabled"
                    @mousedown.native="setDateNow"
                    @click="$emit('reclamation-click')"
                >
                    <a-icon
                        v-if="reclamationIsFetching"
                        style="height: 21px"
                        icon="Spinner"
                    />
                    <span v-else>
                        Reklamuj
                    </span>
                </the-btn>
            </template>

            <template v-else-if="expandable">
                <span class="text-sm retr__expand-text">
                    {{ isActive ? 'Zwiń' : 'Rozwiń' }}
                </span>
                <a-icon
                    v-if="expandable"
                    class="retr__chevron"
                    icon="Chevron"
                />
            </template>
        </div>
    </div>
</template>

<script>
import ReclamationButtonMixin from '@/components/my-business/retr/reclamation-button.mixin'

export default {
    mixins: [ReclamationButtonMixin],

    inject: ['retrType'],

    props: {
        element: {
            type: Object,
            default: undefined
        },
        name: {
            type: String,
            required: true
        },
        value: {
            type: [Number],
            default: NaN
        },
        percent: {
            type: Number,
            default: undefined
        },
        bold: {
            type: Boolean,
            default: false
        },
        expandable: {
            type: Boolean,
            default: false
        },
        reclamationButton: {
            type: Boolean,
            default: false
        },
        isActive: {
            type: Boolean,
            default: false
        },
        percentValue: {
            type: Boolean,
            default: false
        }
    }
}
</script>